import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFireAuth } from '../FireAuthContext';
import { createGame, joinGame } from './LobbyFunctions';
import './Poker.css';

const Poker = () => {
  const { user } = useFireAuth();
  const navigate = useNavigate();
  const [joinCode, setJoinCode] = useState('');
  const [error, setError] = useState('');

  const handleCreateGame = async () => {
    if (user) {
      const gameId = await createGame(user.uid);
      navigate(`/portal/poker/${gameId}`);
    }
  };

  const handleJoinGame = async () => {
    if (user && joinCode) {
      const success = await joinGame(joinCode, user.uid);
      if (success) {
        navigate(`/portal/poker/${joinCode}`);
      } else {
        setError('Invalid or full game code.');
      }
    }
  };

  return (
    <div className="poker-lobby">
      <h2 className="poker-title">Poker Lobby</h2>
      <div className="poker-actions">
        <button className="poker-button" onClick={handleCreateGame}>Create Game</button>
        <div className="poker-join">
          <input
            type="text"
            value={joinCode}
            onChange={(e) => setJoinCode(e.target.value)}
            placeholder="Enter game code"
            className="poker-input"
          />
          <button className="poker-button" onClick={handleJoinGame}>Join Game</button>
        </div>
      </div>
      {error && <p className="poker-error">{error}</p>}
    </div>
  );
};

export default Poker;
